import { APP_MODE, caps } from '../config.svelte';

export interface AnimLimits {
  maxSide: number;
  maxSeconds: number;
  maxFps: number;
  maxFrames: number;
}

/** Browser-side limits (public site and client mode). */
export const CLIENT_LIMITS: AnimLimits = { maxSide: 1280, maxSeconds: 10, maxFps: 30, maxFrames: 300 };

/** Limits applying to the current compute target. Server limits come from `/api/capabilities`. */
export function currentLimits(target: 'client' | 'server'): AnimLimits {
  if (target === 'server' && APP_MODE === 'full' && caps.compute && caps.limits) return caps.limits;
  return CLIENT_LIMITS;
}
